// import { Box } from "@mui/material";
// import { Map } from "mapbox-gl";
// // import polyline from "@mapbox/polyline";

// export const ItemPropertyLocation = ({ coords }) => {

// // const encodedCoords = polyline

//     return (
//         <Box>

//         </Box>
//     );
// }

import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const ItemPropertyLocation = ({ coords }) => {

  const mapContainerRef = useRef(null);

  useEffect(() => {
    if (!coords?.length) return;

    const bounds = coords.reduce((b, [lng, lat]) => {
      return b.extend([lng, lat]);
    }, new mapboxgl.LngLatBounds(coords[0], coords[0]));

    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      interactive: false,
    });

    // calculate span in degrees
    const spanLng = bounds.getEast() - bounds.getWest();
    const spanLat = bounds.getNorth() - bounds.getSouth();
    const span = Math.max(spanLng, spanLat);

    // small span → big padding, large span → small padding
    const padding = Math.min(160, Math.max(20, 160 / (span * 50)));

    map.fitBounds(bounds, { padding: padding, duration: 0 });

    map.on('load', () => {
      map.addSource('polygon', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            coordinates: [coords],
          },
        },
      });

      map.addLayer({
        id: 'polygon-fill',
        type: 'fill',
        source: 'polygon',
        paint: {
          'fill-color': '#ff0000',
          'fill-opacity': 0.5,
        },
      });

      map.addLayer({
        id: 'polygon-outline',
        type: 'line',
        source: 'polygon',
        paint: {
          'line-color': '#ff0000',
          'line-width': 2,
        },
      });
    });

    return () => map.remove();
  }, [coords]);

  return (
    <div
      ref={mapContainerRef}
      style={{ width: '100%', height: '400px', borderRadius: '8px', overflow: 'hidden' }}
    />
  );
};